import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilePreviewType } from 'library-explorer';
import { FileModel } from 'library-explorer';
import { LibraryService } from '@app/services/api/library.service';
import { PreviewDialogConfig } from '../../models/preview-dialog-config';


@Component({
    selector: 'app-preview-modal',
    templateUrl: './preview-modal.component.html',
    styleUrls: ['./preview-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreviewModalComponent implements OnInit {
  public modalHidden = false;
  public isLoaded = false;
  public fileMode: FilePreviewType;
  public isSizeLimitExceeded = false;
  
  private OFFICE_FILE_LIMIT = 10 * 1000 * 1000; // 10 MB

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PreviewDialogConfig,
    private libraryService: LibraryService
  ) {  }

  public ngOnInit(): void {
    this.fileMode = this.data.mode;
    this.modalHidden = this.fileMode === FilePreviewType.VIDEO_VIEWER && !this.isLoaded;
    
    this.isSizeLimitExceeded = this.fileMode === FilePreviewType.OFFICE_VIEWER && this.data.file.fileSize > this.OFFICE_FILE_LIMIT;
    if (this.isSizeLimitExceeded) {
      this.isLoaded = true;
    }
  }
  
  public download(): void {
    this.libraryService.downloadLibraryFile(this.data as any);
  }

  public loaded(loaded: boolean): void {
    setTimeout(() => {
      this.isLoaded = loaded;
      this.modalHidden = this.fileMode === FilePreviewType.VIDEO_VIEWER && !this.isLoaded;
    }, 100);
  }
}
